exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-left-2[data-v-7052ac61]{margin-left:4px}.margin-left-2[data-v-7052ac61]:first-child{margin-left:0}", ""]);

// exports
